(function () {
  function init() {
    var root = document.querySelector('[data-self-reflection]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var placeholder = root.querySelector('[data-sr-placeholder]');
    var video = root.querySelector('[data-sr-video]');
    var canvas = root.querySelector('[data-sr-canvas]');
    var tracker = root.querySelector('[data-sr-tracker]');
    var reading = root.querySelector('[data-sr-reading]');
    var result = root.querySelector('[data-sr-result]');
    var photoResult = root.querySelector('[data-sr-photo-result]');
    var videoResult = root.querySelector('[data-sr-video-result]');
    var beforeControls = root.querySelector('[data-sr-before]');
    var liveControls = root.querySelector('[data-sr-live-controls]');
    var captureControls = root.querySelector('[data-sr-capture-controls]');
    var startButton = root.querySelector('[data-sr-start]');
    var photoButton = root.querySelector('[data-sr-photo]');
    var recordButton = root.querySelector('[data-sr-record]');
    var stopButton = root.querySelector('[data-sr-stop]');
    var downloadButton = root.querySelector('[data-sr-download]');
    var shareButton = root.querySelector('[data-sr-share]');
    var retakeButton = root.querySelector('[data-sr-retake]');
    var cameraArea = placeholder ? placeholder.parentElement : null;
    if (!video || !canvas || !startButton || !photoButton || !recordButton) return;

    var stream = null;
    var drawFrame = null;
    var recorder = null;
    var chunks = [];
    var recording = false;
    var frozenPhoto = false;
    var currentBlob = null;
    var currentFilename = '';
    var currentObjectUrl = '';
    var currentMode = '';
    var recordingCanvas = null;
    var recordingLoop = null;
    var recordingStream = null;

    function isMobileLayout() {
      return window.matchMedia && window.matchMedia('(max-width: 900px)').matches;
    }

    function exportSize() {
      return isMobileLayout()
        ? { width: 1080, height: 1920 }
        : { width: 1920, height: 1080 };
    }

    function placeBeginInCenter() {
      if (!beforeControls || !cameraArea) return;
      if (beforeControls.parentElement !== cameraArea) cameraArea.appendChild(beforeControls);
      cameraArea.style.position = 'relative';
      beforeControls.style.position = 'absolute';
      beforeControls.style.left = '50%';
      beforeControls.style.top = '50%';
      beforeControls.style.right = 'auto';
      beforeControls.style.bottom = 'auto';
      beforeControls.style.transform = 'translate(-50%, -50%)';
      beforeControls.style.width = 'min(520px, calc(100% - 44px))';
      beforeControls.style.maxWidth = 'calc(100% - 44px)';
      beforeControls.style.margin = '0';
      beforeControls.style.zIndex = '14';
    }

    function setButton(button, disabled, text) {
      if (!button) return;
      button.disabled = !!disabled;
      if (text) button.textContent = text;
    }

    function revokeCurrentUrl() {
      if (currentObjectUrl) URL.revokeObjectURL(currentObjectUrl);
      currentObjectUrl = '';
    }

    function cameraConstraints() {
      if (isMobileLayout()) {
        return { video: { facingMode: { ideal: 'user' }, width: { ideal: 1080 }, height: { ideal: 1920 }, aspectRatio: { ideal: 0.5625 } }, audio: false };
      }
      return { video: { facingMode: { ideal: 'user' }, width: { ideal: 1920 }, height: { ideal: 1080 }, aspectRatio: { ideal: 1.7777777778 } }, audio: false };
    }

    function showLive() {
      if (placeholder) placeholder.hidden = true;
      video.hidden = false;
      canvas.hidden = false;
      if (tracker) tracker.hidden = false;
      if (reading) reading.hidden = false;
      if (beforeControls) beforeControls.hidden = true;
      if (liveControls) liveControls.hidden = false;
      if (captureControls) captureControls.hidden = true;
      if (result) result.hidden = true;
    }

    function showStart() {
      placeBeginInCenter();
      if (placeholder) placeholder.hidden = false;
      video.hidden = true;
      canvas.hidden = true;
      if (tracker) tracker.hidden = true;
      if (reading) reading.hidden = true;
      if (beforeControls) beforeControls.hidden = false;
      if (liveControls) liveControls.hidden = true;
      if (captureControls) captureControls.hidden = true;
      if (result) result.hidden = true;
    }

    function showCapturedControls() {
      if (liveControls) liveControls.hidden = true;
      if (captureControls) captureControls.hidden = false;
    }

    function showVideoResult() {
      showCapturedControls();
      if (result) result.hidden = false;
    }

    function resizeCanvas() {
      if (video.hidden) return;
      var rect = video.getBoundingClientRect();
      canvas.width = Math.max(1, Math.round(rect.width));
      canvas.height = Math.max(1, Math.round(rect.height));
    }

    function coverRect(sourceWidth, sourceHeight, targetWidth, targetHeight) {
      var scale = Math.max(targetWidth / sourceWidth, targetHeight / sourceHeight);
      var width = sourceWidth * scale;
      var height = sourceHeight * scale;
      return { x: (targetWidth - width) / 2, y: (targetHeight - height) / 2, width: width, height: height };
    }

    function drawCameraFrame(ctx, source, width, height, mirrored) {
      var sw = source.videoWidth;
      var sh = source.videoHeight;
      if (!sw || !sh) return;
      var rect = coverRect(sw, sh, width, height);
      ctx.save();
      ctx.fillStyle = '#000';
      ctx.fillRect(0, 0, width, height);
      if (mirrored) {
        ctx.translate(width, 0);
        ctx.scale(-1, 1);
        ctx.drawImage(source, width - rect.x - rect.width, rect.y, rect.width, rect.height);
      } else {
        ctx.drawImage(source, rect.x, rect.y, rect.width, rect.height);
      }
      ctx.restore();
    }

    function drawCanvasCover(ctx, sourceCanvas, targetWidth, targetHeight) {
      if (!sourceCanvas || !sourceCanvas.width || !sourceCanvas.height) return;
      var rect = coverRect(sourceCanvas.width, sourceCanvas.height, targetWidth, targetHeight);
      ctx.drawImage(sourceCanvas, rect.x, rect.y, rect.width, rect.height);
    }

    function drawVisibleComposite(targetCanvas) {
      if (!targetCanvas) return;
      var ctx = targetCanvas.getContext('2d');
      ctx.clearRect(0, 0, targetCanvas.width, targetCanvas.height);
      ctx.fillStyle = '#000';
      ctx.fillRect(0, 0, targetCanvas.width, targetCanvas.height);

      if (canvas && canvas.width && canvas.height) {
        drawCanvasCover(ctx, canvas, targetCanvas.width, targetCanvas.height);
      } else if (video.readyState >= 2) {
        drawCameraFrame(ctx, video, targetCanvas.width, targetCanvas.height, true);
      }

      if (tracker && !tracker.hidden && tracker.width && tracker.height) {
        drawCanvasCover(ctx, tracker, targetCanvas.width, targetCanvas.height);
      }
    }

    function drawOnce() {
      if (stream && video.readyState >= 2 && canvas.width && canvas.height) {
        drawCameraFrame(canvas.getContext('2d'), video, canvas.width, canvas.height, true);
      }
    }

    function beginDrawLoop() {
      cancelAnimationFrame(drawFrame);
      function draw() {
        if (!frozenPhoto) drawOnce();
        drawFrame = requestAnimationFrame(draw);
      }
      draw();
    }

    async function startCamera() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) return;
      setButton(startButton, true, 'REQUESTING...');
      try {
        stream = await navigator.mediaDevices.getUserMedia(cameraConstraints());
        video.srcObject = stream;
        video.muted = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('autoplay', '');
        showLive();
        await video.play();
        frozenPhoto = false;
        resizeCanvas();
        beginDrawLoop();
      } catch (error) {
        console.error(error);
        stopTracks();
        showStart();
      } finally {
        setButton(startButton, false, 'BEGIN');
      }
    }

    function freezePhoto(event) {
      if (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      if (!stream || video.readyState < 2) return;
      currentMode = 'photo';
      frozenPhoto = true;
      resizeCanvas();
      drawOnce();
      try { video.pause(); } catch (error) {}
      currentBlob = null;
      currentFilename = 'aeliza-self-reflection.jpg';
      revokeCurrentUrl();
      if (result) result.hidden = true;
      if (photoResult) {
        photoResult.hidden = true;
        photoResult.removeAttribute('src');
      }
      if (videoResult) {
        videoResult.hidden = true;
        videoResult.removeAttribute('src');
        videoResult.style.transform = '';
      }
      showCapturedControls();
      root.dispatchEvent(new CustomEvent('sr:capture'));
    }

    function makeExportPhotoCanvas() {
      var size = exportSize();
      var out = document.createElement('canvas');
      out.width = size.width;
      out.height = size.height;
      drawVisibleComposite(out);
      return out;
    }

    function createPhotoBlob(callback) {
      if (currentBlob) {
        callback(currentBlob);
        return;
      }
      try {
        var out = makeExportPhotoCanvas();
        if (out.toBlob) {
          out.toBlob(function (blob) {
            currentBlob = blob;
            callback(blob);
          }, 'image/jpeg', 0.92);
        } else {
          var dataUrl = out.toDataURL('image/jpeg', 0.92);
          var parts = dataUrl.split(',');
          var mime = (parts[0].match(/:(.*?);/) || [])[1] || 'image/jpeg';
          var binary = atob(parts[1]);
          var bytes = new Uint8Array(binary.length);
          for (var i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
          currentBlob = new Blob([bytes], { type: mime });
          callback(currentBlob);
        }
      } catch (error) {
        console.error(error);
        callback(null);
      }
    }

    function chooseMimeType() {
      var types = ['video/mp4;codecs=avc1.42E01E', 'video/mp4', 'video/webm;codecs=vp8', 'video/webm'];
      for (var i = 0; i < types.length; i += 1) {
        if (window.MediaRecorder && MediaRecorder.isTypeSupported(types[i])) return types[i];
      }
      return '';
    }

    function stopRecordingComposite() {
      cancelAnimationFrame(recordingLoop);
      recordingLoop = null;
      if (recordingStream) recordingStream.getTracks().forEach(function (track) { track.stop(); });
      recordingStream = null;
    }

    function startRecordingComposite() {
      stopRecordingComposite();
      var size = exportSize();
      recordingCanvas = document.createElement('canvas');
      recordingCanvas.width = size.width;
      recordingCanvas.height = size.height;

      function draw() {
        if (recordingCanvas) drawVisibleComposite(recordingCanvas);
        recordingLoop = requestAnimationFrame(draw);
      }
      draw();

      if (!recordingCanvas.captureStream) return null;
      recordingStream = recordingCanvas.captureStream(24);
      return recordingStream;
    }

    function toggleRecording(event) {
      if (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      if (!stream || !window.MediaRecorder) return;

      if (recording) {
        try {
          if (recorder && recorder.state !== 'inactive') recorder.stop();
        } catch (error) {
          console.error(error);
        }
        return;
      }

      try {
        currentMode = 'video';
        frozenPhoto = false;
        if (result) result.hidden = true;
        if (video.paused) video.play();
        chunks = [];
        var mimeType = chooseMimeType();
        var exportStream = startRecordingComposite() || stream;
        recorder = new MediaRecorder(exportStream, mimeType ? { mimeType: mimeType } : undefined);
        recorder.ondataavailable = function (event) {
          if (event.data && event.data.size) chunks.push(event.data);
        };
        recorder.onstop = function () {
          stopRecordingComposite();
          recording = false;
          setButton(recordButton, false, 'RECORD VIDEO');
          if (!chunks.length) return;
          var type = recorder.mimeType || mimeType || 'video/webm';
          currentBlob = new Blob(chunks, { type: type });
          currentFilename = type.indexOf('mp4') > -1 ? 'aeliza-self-reflection.mp4' : 'aeliza-self-reflection.webm';
          revokeCurrentUrl();
          currentObjectUrl = URL.createObjectURL(currentBlob);
          if (videoResult) {
            videoResult.src = currentObjectUrl;
            videoResult.hidden = false;
            videoResult.style.transform = '';
          }
          if (photoResult) {
            photoResult.hidden = true;
            photoResult.removeAttribute('src');
          }
          frozenPhoto = true;
          try { video.pause(); } catch (error) {}
          showVideoResult();
          root.dispatchEvent(new CustomEvent('sr:capture'));
        };
        recorder.onerror = function (error) {
          stopRecordingComposite();
          console.error(error);
          recording = false;
          setButton(recordButton, false, 'RECORD VIDEO');
        };
        recorder.start();
        recording = true;
        setButton(recordButton, false, 'STOP RECORDING');
      } catch (error) {
        stopRecordingComposite();
        console.error(error);
        recording = false;
        setButton(recordButton, false, 'RECORD VIDEO');
      }
    }

    function downloadBlob(blob, filename) {
      if (!blob) return;
      var link = document.createElement('a');
      var url = URL.createObjectURL(blob);
      link.href = url;
      link.download = filename;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
    }

    function downloadCapture(event) {
      if (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      if (currentMode === 'photo' || (currentFilename && currentFilename.indexOf('.jpg') > -1)) {
        createPhotoBlob(function (blob) { downloadBlob(blob, currentFilename || 'aeliza-self-reflection.jpg'); });
        return;
      }
      downloadBlob(currentBlob, currentFilename || 'aeliza-self-reflection.webm');
    }

    function shareCapture(event) {
      if (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      function shareBlob(blob) {
        if (!blob) return;
        var file = new File([blob], currentFilename, { type: blob.type || 'application/octet-stream' });
        if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
          navigator.share({ files: [file], title: 'AELIZA: SELF REFLECTION' }).catch(function (error) {
            if (error.name !== 'AbortError') console.error(error);
          });
        } else {
          downloadBlob(blob, currentFilename);
        }
      }
      if (currentMode === 'photo' || (currentFilename && currentFilename.indexOf('.jpg') > -1)) createPhotoBlob(shareBlob);
      else shareBlob(currentBlob);
    }

    function clearResult(event) {
      if (event) event.stopImmediatePropagation();
      stopRecordingComposite();
      currentBlob = null;
      currentFilename = '';
      currentMode = '';
      revokeCurrentUrl();
      frozenPhoto = false;
      if (result) result.hidden = true;
      if (photoResult) {
        photoResult.hidden = true;
        photoResult.removeAttribute('src');
      }
      if (videoResult) {
        videoResult.hidden = true;
        videoResult.removeAttribute('src');
        videoResult.style.transform = '';
      }
      if (liveControls) liveControls.hidden = false;
      if (captureControls) captureControls.hidden = true;
      try { if (stream && video.paused) video.play(); } catch (error) {}
      beginDrawLoop();
      root.dispatchEvent(new CustomEvent('sr:retake'));
    }

    function stopTracks() {
      stopRecordingComposite();
      if (stream) stream.getTracks().forEach(function (track) { track.stop(); });
      stream = null;
    }

    function stopCamera() {
      if (recording && recorder && recorder.state !== 'inactive') recorder.stop();
      stopTracks();
      cancelAnimationFrame(drawFrame);
      video.srcObject = null;
      clearResult();
      showStart();
    }

    placeBeginInCenter();
    startButton.addEventListener('click', startCamera);
    photoButton.addEventListener('click', freezePhoto, true);
    recordButton.addEventListener('click', toggleRecording, true);
    if (stopButton) stopButton.addEventListener('click', stopCamera);
    if (downloadButton) downloadButton.addEventListener('click', downloadCapture, true);
    if (shareButton) shareButton.addEventListener('click', shareCapture, true);
    if (retakeButton) retakeButton.addEventListener('click', clearResult, true);
    window.addEventListener('resize', function () { placeBeginInCenter(); resizeCanvas(); drawOnce(); });
    window.addEventListener('pagehide', stopTracks);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
